
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branding",
      function () {
        return require("private-next-pages/branding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branding"])
      });
    }
  